import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReferenceDataLabels } from '../../lib/constants/reference-data-labels';
import { BaseCollectionComponent } from '../base-collection.component';
import { ReferenceDataService } from './../../lib/services/reference-data.service';

@Component({
  selector: 'boi-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DropDownComponent,
      multi: true
    }
  ]
})
export class DropDownComponent extends BaseCollectionComponent {
  @Input() public dropDownLabel?: string;
  @Input() public valuePrimitive = true;
  @Input() public hasDefaultItem = true;
  @Input() public forceRequired: boolean;
  @Input() public dropDownPopupCssClass: string;
  @Input() public isTooltipLast = true;

  constructor(
    protected readonly referenceDataService: ReferenceDataService,
    protected readonly cdRef: ChangeDetectorRef
  ) {
    super(cdRef);
  }

  private _defaultItem: any;
  @Input() public get defaultItem(): any {
    if (!this._defaultItem) {
      this.setDefaultItem();
    }

    return this._defaultItem;
  }

  public set defaultItem(defaultItem: any) {
    this._defaultItem = defaultItem;
  }

  private setDefaultItem(): any {
    if (this.hasDefaultItem) {
      this._defaultItem = this.optionList
        ? { Value: this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.PleaseSelect), Code: undefined }
        : this.createDefaultItem();
    }
  }

  private createDefaultItem(): any {
    const defaultItem = {};
    defaultItem[this.textField] = this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.PleaseSelect);
    defaultItem[this.valueField] = undefined;

    return defaultItem;
  }
}
